import { render, staticRenderFns } from "./61.vue?vue&type=template&id=8d1b2c7c&scoped=true&"
import script from "./61.vue?vue&type=script&lang=js&"
export * from "./61.vue?vue&type=script&lang=js&"
import style0 from "./61.vue?vue&type=style&index=0&id=8d1b2c7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1b2c7c",
  null
  
)

export default component.exports